import { useOutletContext } from 'react-router-dom';
import {
  AccessComponentEnum,
  AccessLevelEnum,
  CompanyPlanUpgradeFeatureEnum,
  User,
} from 'graphql-common';
import { PlanState } from '@lib/enums/plan';

export type ContextProps = {
  getUserAccessByCompany: (component: AccessComponentEnum) => AccessLevelEnum;
  getUserAccessByComponent: (component: AccessComponentEnum) => AccessLevelEnum;
  getUserAccessByUrl: (pathname: string) => AccessLevelEnum;
  getUserAccessItemIdsByComponent: (component: AccessComponentEnum) => string[];
  handleOpenPlanModal: (
    state: PlanState,
    features?: CompanyPlanUpgradeFeatureEnum[],
  ) => void;
  isFullAdmin: boolean;
  onLogoutHandler: () => void;
  user: User;
};

export default function useOutletContextHook() {
  const outletContext: ContextProps = useOutletContext();
  return outletContext;
}
